import { Component } from '@angular/core';

@Component({
    selector: 'lib-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.css'],
    standalone: false
})
export class UnauthorizedComponent{

}
